(function ($, Drupal, drupalSettings, once) {
  'use strict';

  $(document).ready(function () {
    $('.stage-counter span').each(function (index) {
      $(this).prepend((index + 1) + '. ');
    });
  });

  Drupal.behaviors.customBehavior = {
    attach: function (context, settings) {
      $(once('customBehavior', '.stages-inner > .stage.highlight, .stage-highlights', context)).click(function (e) {
        // Get the current node ID
        var enabledIDs = $('#gallery-overlay').data('enabledids');
        if (!enabledIDs) {
          return;
        }
        let currentStage = $(e.currentTarget).data('stage-id');
        // Load the gallery content via AJAX
        $.ajax({
          url: `/etappen-lightbox/${enabledIDs}`,
          success: function (data) {
            let slideIndex = enabledIDs.split('+').indexOf(currentStage.toString()) ?? 0;
            $('#gallery-overlay .gallery-content .slider').html(data);
            $('.slick__slider').slick({'dots': true, 'arrows': false, 'infinite': false, 'speed': 300, 'slidesToShow': 1, 'initialSlide': slideIndex});
            $('body').addClass('gallery-open');
            $('#gallery-overlay').fadeIn();
          },
          error: function (error) {
          }
        });
      });

      // Close the overlay
      $('#gallery-overlay').mousedown(function (event) {
        if (event.target === this) {
          $('body').removeClass('gallery-open');
          $(this).fadeOut();
        }
      });
      // Close the overlay
      $('.close-overlay, .button.book-now').click(function (event) {
        $('body').removeClass('gallery-open');
        $('#gallery-overlay').fadeOut();
      });

      $('.slick__arrow .slick__next').click(() => {
        if($('.slick__slider').length > 0) {
          $('.slick__slider').slick('slickNext');
        }
      })
      $('.slick__arrow .slick__prev').click(() => {
        if($('.slick__slider').length > 0) {
          $('.slick__slider').slick('slickPrev');
        }
      })
    }
  };
})(jQuery, Drupal, drupalSettings, once);
